import { Serializable } from '../../../core/models/serializable';
export class CustomerContractTypeModel
  implements Serializable<CustomerContractTypeModel>
{
  fromObject(obj: any): CustomerContractTypeModel {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    let result = {
      CustomerContractTypeId: this.customerContractTypeId,
      Name: this.name,
    };
    return result;
  }

  public customerContractTypeId: number;
  public name: String;
}
